import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminUserActions'
import { initialFormState } from '../resetPassword'

const profileFor = (state = null, action) => {
  switch (action.type) {
    case actions.ADMIN_PASSWORD_RESET_VIEW:
      return action.userId

    case actions.CLEAR_ADMIN_PASSWORD_RESET:
      return null

    default:
      return state
  }
}

export default combineReducers({
  profileFor,
  updateRequest: h2Api.restReducer(actions.ADMIN_PASSWORD_RESET_REQUEST),
  form: modelReducer('admin.users.passwordReset.form', initialFormState),
  forms: formReducer('admin.users.passwordReset', { form: initialFormState })
})
